module.exports = __webpack_public_path__ + "assets/AngleMidpointDetailed.2f0652e116e746fbd91058f825418c04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/AngleMidpointDetailed.png
// module id = 467
// module chunks = 0